import { Dispatch, SetStateAction, useRef } from 'react'
import classNames from 'classnames'
import Overlay from '../header/overlay'
import { TDesktopDropDownOverlay } from './types/types'
import { headerV3Config } from './constants/header-v2-config'
import DropdownOverlayChildV3 from './DropdownOverlayChildV3'

type TProps = {
  dwebDropdown: TDesktopDropDownOverlay
  toggleDwebDropdown: Dispatch<SetStateAction<TDesktopDropDownOverlay>>
}
const DropdownOverlay = ({ dwebDropdown, toggleDwebDropdown }: TProps) => {
  const overlayHeightRef = useRef<HTMLInputElement | null>(null)

  return (
    <div
      className="absolute bottom-0 z-[1000] w-screen bg-brand-white"
      ref={overlayHeightRef}
    >
      <div className="hidden lg:block">
        {dwebDropdown && (
          <Overlay>
            <div
              className="fixed left-0 top-0 z-40 h-screen w-screen bg-brand-black opacity-60"
              onClick={() => {
                toggleDwebDropdown(null)
              }}
            />
          </Overlay>
        )}
      </div>
      <div
        className={classNames(
          'mt-1 overflow-hidden bg-brand-white shadow-one',
          'absolute left-[30%] rounded-md',
          {
            'invisible opacity-0 transition-all duration-100 ease-in-out':
              !dwebDropdown,
            'min-w-[500px]  translate-x-[-54%]': dwebDropdown === 'Invest',
            'min-w-[300px]  translate-x-[-30%]': dwebDropdown === 'Disclosure',
          },
        )}
      >
        {headerV3Config.map((item, index) => {
          if (item.list1 || item.list2) {
            return (
              <DropdownOverlayChildV3
                key={`${item.title}-${index}`}
                isOpen={dwebDropdown === item.title}
                onClose={() => {
                  toggleDwebDropdown(null)
                }}
                {...item}
                section={dwebDropdown}
              />
            )
          } else {
            return null
          }
        })}
      </div>
    </div>
  )
}

export default DropdownOverlay
